enum CartUpsellLayoutEnum {
    FULL_SCREEN = "FULL_SCREEN",
    ROWS = "ROWS",
}

export default CartUpsellLayoutEnum;
